import { render, staticRenderFns } from "./OrgUser.vue?vue&type=template&id=45d5a595&scoped=true&"
import script from "./OrgUser.vue?vue&type=script&lang=js&"
export * from "./OrgUser.vue?vue&type=script&lang=js&"
import style0 from "./OrgUser.vue?vue&type=style&index=0&id=45d5a595&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d5a595",
  null
  
)

component.options.__file = "OrgUser.vue"
export default component.exports